import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { MediaBP } from 'src/styles/mediaQuery';

export const gradientOverlay = css`
  width: 100%;
  position: absolute;
  content: '';
  left: 0;
  top: 0;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(37, 30, 43, 0) 46.5%,
    rgba(37, 30, 43, 0.5) 70.5%,
    rgba(37, 30, 43, 0.85) 90%,
    rgba(37, 30, 43, 1) 100%
  );

  ${MediaBP.MediaLg} {
    background: linear-gradient(90deg, #251e2b 0%, rgba(37, 30, 43, 0) 22.7%);
  }
`;
export const ImageContainer = styled.img`
  width: 100%;
`;
export const topContainer = css`
  width: 100%;
  position: relative;
  &:after {
    ${gradientOverlay};
  }
  ${MediaBP.MediaLg} {
    flex: 1;
  } ;
`;

export const desktopImageContainer = css`
  height: 80vh;
  width: 100%;
  position: relative;
`;

export const topHalf = css`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  clip-path: ellipse(200px 20px at 10% 20%);
`;
export const bottomHalf = css`
  position: absolute;
  top: 50%;
  left: 0;
`;
